export default __webpack_public_path__ + "static/media/pic4.f57d107e.jpg";